const u = '${{amount}}';
function _(a, c) {
  typeof a == 'string' && (a = a.replace('.', ''));
  let t = '';
  const s = /\{\{\s*(\w+)\s*\}\}/,
    n = c || u;
  function e(o, i = 2, m = ',', l = '.') {
    if (isNaN(o) || o == null) return 0;
    o = (o / 100).toFixed(i);
    const r = o.split('.'),
      d = r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${m}`),
      p = r[1] ? l + r[1] : '';
    return d + p;
  }
  switch (n.match(s)[1]) {
    case 'amount':
      t = e(a, 2);
      break;
    case 'amount_no_decimals':
      t = e(a, 0);
      break;
    case 'amount_with_comma_separator':
      t = e(a, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      t = e(a, 0, '.', ',');
      break;
  }
  return n.replace(s, t);
}
export {_ as f};
